export default {
    ordersLayout: {
        back: "Назад",
        emptyOrders: "У вас пока нет заказов.",
        loading: "Загрузка",
        storeLabel: "Бутик",
        totalLabel: "Итого",
        storeAddressPending: "Адрес скоро будет доступен",
        productNameFallback: "Товар",
        ecListTitle: "Ваши заказы",
        ecStatusInStore: "Статус: покупка в бутике",
        ecOrderNumber: "Номер заказа: {{order_number}}",
        ecDateStore: "{{date}} · {{store_name}}",
        ecCountTotalOne: "{{count}} шт.: итого {{amount}}",
        ecCountTotalOther: "{{count}} шт.: итого {{amount}}",
        ecViewOrder: "Посмотреть заказ >",
        ecViewOrderA11y: "Посмотреть заказ {{order_number}}",
        ecBackToOrders: "Вернуться к заказам",
        ecInStoreDate: "Покупка в бутике – {{date}}",
        ecProductsOne: "Товар",
        ecProductsOther: "Товары",
        ecSku: "Арт. {{sku}}",
        ecQty: "Количество: {{qty}}",
        ecWarrantyExpired: "Гарантия истекла",
        ecWarrantyActive: "Действует гарантия",
        ecSubtotalOne: "Промежуточный итог – {{count}} шт.",
        ecSubtotalOther: "Промежуточный итог – {{count}} шт.",
    }
}



// WEBPACK FOOTER //
// ./src/locales/ru/index.js